// This is a Renderless component. This means that we are bypassing a Template section,
// and instead using the render() function to just render the default slot.
//
// The parent is responsible for passing in the entire template that will be rendered,
// which will receive the `data` prop to do with as it pleases.
//
// For an example, see JobsIndex.vue
//
// - Jordan Kicklighter 2019-05-07

<script>
  import GenericStoreCoordinatorService from 'Services/genericStoreCoordinator/Service'

  export default {
    name: 'generic-store-backed-collection',
    render () {
      return this.$scopedSlots.default({
        data: this.data,
        loading: this.loading,
      })
    },
    data () {
      return {
        coordinator: GenericStoreCoordinatorService.getById(this.uuid),
      }
    },
    fromMobx: {
      data () {
        return this.coordinator.records
      },
      loading () {
        return this.coordinator.loadingData.any
      },
    },
    props: {
      uuid: {
        type: String,
        required: true,
      },
    },
    computed: {
    },
    methods: {
    },
  }
</script>
